import { Action, CoverageIssue, CoverageTestResult } from '~/components/Claim/Actions/types';

const generateCoverageTestResultMarkdown = (testDescription: string, testPassed: boolean, issue?: CoverageIssue) => {
  let markdown = '';

  // Header with test description and status
  markdown += `## ${testDescription}\n\n`;

  const status = testPassed ? '✅ *PASSED*' : '⚠️ *ISSUE*';
  markdown += `*Status:* ${status}\n\n`;

  // If test failed and issue exists, add issue details
  if (!testPassed && issue) {
    markdown += '### Coverage Issue:\n\n';
    markdown += `- ${issue.issue_description}\n`;
    if (issue.explanation) {
      markdown += `  ${issue.explanation}\n`;
    }
    markdown += '\n';

    // Statement from policy (if exists)
    if (issue.quote_from_policy) {
      markdown += '### Statement from policy:\n\n';
      markdown += `> "${issue.quote_from_policy}"\n\n`;
    }

    // Relevant claim information (if exists)
    if (issue.quote_from_incident) {
      markdown += '### Relevant claim information:\n\n';
      markdown += `${issue.quote_from_incident}\n\n`;
    }

    // Recommended action
    markdown += '### Recommended Action:\n\n';
    const actionText = issue.recommended_action === 'deny' ? 'Consider Coverage' : 'Approve Coverage';
    markdown += `🎯 **${actionText}**\n\n`;
  }

  return markdown;
};

export const processCoverageDecisionContent = (action: Action): string => {
  const coverageTests = (action?.metadata?.coverage_tests ?? []) as CoverageTestResult[];
  const markdownParts = coverageTests.map((coverageTest: CoverageTestResult) =>
    generateCoverageTestResultMarkdown(coverageTest.test_description, coverageTest.test_passed, coverageTest.issue)
  );

  return markdownParts.join('\n');
};
